import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  _id: string;
  name: string;
  email: string;
  days: number;
  startDate: string;
  destinations: string[];
  roomSharing: string;
  status: string;
  createdAt: string;
};

const columnHelper = createColumnHelper<RowObj>();
const columns = [
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <p className="">EMAIL</p>,
    cell: (info) => <p className="">{info.getValue()}</p>,
  }),
  columnHelper.accessor('days', {
    id: 'days',
    header: () => <p className="">DAYS</p>,
    cell: (info) => <p className="">{info.getValue()}</p>,
  }),
  columnHelper.accessor('startDate', {
    id: 'startDate',
    header: () => <p className="">START DATE</p>,
    cell: (info) => <p className="">{new Date(info.getValue()).toLocaleDateString()}</p>,
  }),
  columnHelper.accessor('destinations', {
    id: 'destinations',
    header: () => <p className="">DESTINATIONS</p>,
    cell: (info) => (
      <p className="">
        {info.getValue()?.slice(0, 2).join(', ')}
        {info.getValue()?.length > 2 && '...'}
      </p>
    ),
  }),
  columnHelper.accessor('roomSharing', {
    id: 'roomSharing',
    header: () => <p className="">ROOM</p>,
    cell: (info) => <p className="">{info.getValue()}</p>,
  }),
  columnHelper.accessor('status', {
    id: 'status',
    header: () => <p className="">STATUS</p>,
    cell: (info) => {
      const status = info.getValue();
      let color = '';
      switch (status) {
        case 'pending':
          color = 'bg-yellow-100 text-yellow-800';
          break;
        case 'contacted':
          color = 'bg-blue-100 text-blue-800';
          break;
        case 'processing':
          color = 'bg-purple-100 text-purple-800';
          break;
        case 'confirmed':
          color = 'bg-green-100 text-green-800';
          break;
        case 'cancelled':
          color = 'bg-red-100 text-red-800';
          break;
        default:
          color = 'bg-gray-100 text-gray-800';
      }
      return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}>
          {status}
        </span>
      );
    },
  }),
  columnHelper.accessor('_id', {
    id: '_id',
    header: () => <p className="">ACTION</p>,
    cell: (info) => (
      <Link to={`/admin/custom-trips/${info.getValue()}`}>
        <Button extraClasses="bg-brand text-white hover:bg-brand-dark">
          View Details
        </Button>
      </Link>
    ),
  }),
];

const filters: IFilter[] = [
  { 
    key: 'status', 
    type: 'select', 
    label: 'Status',
    options: ['pending', 'contacted', 'processing', 'confirmed', 'cancelled']
  },
  // { key: 'startDateFrom', type: 'date', label: 'Start Date From' },
  { key: 'startDateTo', type: 'date', label: 'Start Date To' },
];

const CustomTrips = () => {
  const { getApi } = UseApi();

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;
    const response = await getApi(
      `customTrips?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.customTrips;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }

  return (
    <div>
      <ComplexTable 
        columns={columns} 
        fetchData={fetchData} 
        filters={filters}
      />
    </div>
  );
};

export default CustomTrips;